import React from "react";
import NoteSection from "@/components/shownotes/NoteSection";
import ExpandField from "@/components/shownotes/ExpandField";
import { DEPTS } from "@/components/shownotes/meta";

// Section 3: one text box per department.
export default function DeptNotes({ fields, set }) {
  const setDept = (k, v) => set({ dept: { ...fields.dept, [k]: v } });
  return (
    <NoteSection title="Department Notes" testId="notes-section-dept">
      <div className="grid gap-4 sm:grid-cols-2">
        {DEPTS.map(([k, label]) => (
          <ExpandField key={k} label={label} wide={k === "general_comments"} value={fields.dept[k]} onChange={(v) => setDept(k, v)} testId={`notes-dept-${k}`} />
        ))}
      </div>
    </NoteSection>
  );
}
